"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filters = void 0;
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("lodash"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var React = tslib_1.__importStar(require("react"));
var LeftRailButton_1 = require("../../containers/LeftRailButton/LeftRailButton");
var LeftRailShowMore_1 = require("../../containers/LeftRailShowMore/LeftRailShowMore");
require("./styles.less");
var Filters = /** @class */ (function (_super) {
    tslib_1.__extends(Filters, _super);
    function Filters() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpened: false,
        };
        _this.getNextFilters = function (filterName) {
            // tslint:disable-next-line
            _this.props.filterStore.changeFilterPage(filterName, 1);
        };
        _this.onFilterClick = function (filter) {
            // tslint:disable-next-line
            var filterStore = _this.props.filterStore;
            // tslint:disable-next-line
            var timelineStore = _this.props.timelineStore;
            if (filter.value === filterStore.currentFilters[filter.title]) {
                return;
            }
            filterStore.changeFilter(filter);
            timelineStore.index = 1;
            timelineStore.resetTimeline();
            timelineStore.fetchTimeline();
            // tslint:disable-next-line
            _this.props.globalStore.hashRouterService.setHashParam(filterStore.currentFilters);
        };
        _this.resetFilters = function () {
            // tslint:disable-next-line
            var filterStore = _this.props.filterStore;
            // tslint:disable-next-line
            var timelineStore = _this.props.timelineStore;
            // clear url filter override
            _this.removeHash();
            if (_.isEqual(mobx_1.toJS(filterStore.currentFilters), filterStore.defaultFilters)) {
                return;
            }
            filterStore.resetFilters();
            timelineStore.index = 1;
            timelineStore.resetTimeline();
            timelineStore.fetchTimeline();
            // tslint:disable-next-line
            _this.props.globalStore.hashRouterService.setHashParam(filterStore.currentFilters);
        };
        _this.toggleVisibility = function () {
            _this.setState({
                isOpened: !_this.state.isOpened,
            });
        };
        return _this;
    }
    Filters.prototype.componentDidMount = function () {
        // tslint:disable-next-line
        var filterStore = this.props.filterStore;
        filterStore.initFilters(this.props.filters);
        // tslint:disable-next-line
        var hashParams = this.props.globalStore.hashRouterService.parseParams();
        filterStore.currentFilters = _.merge(mobx_1.toJS(filterStore.currentFilters), hashParams);
    };
    Filters.prototype.configureFilterBlocks = function () {
        var _this = this;
        // tslint:disable-next-line
        var _a = this.props.filterStore, isKeyFilter = _a.isKeyFilter, getFilterTitle = _a.getFilterTitle, filtersPage = _a.filtersPage;
        return Object.keys(this.props.filters).map(function (filterName) {
            if (!isKeyFilter(filterName)) {
                return null;
            }
            var showMore = null;
            var filters = _this.configureFilters(_this.props.filters[filterName].slice(0, 5 * filtersPage[filterName]), filterName);
            var getNextFilters = function () {
                _this.getNextFilters(filterName);
            };
            if (_this.props.filters[filterName].length > filtersPage[filterName] * 5) {
                showMore = (React.createElement(LeftRailShowMore_1.LeftRailShowMore, { onClick: getNextFilters, className: 'm-filters__show' }));
            }
            return (React.createElement("section", { className: 'm-filters__item', key: filterName },
                React.createElement("h4", { className: 'm-filters__title' }, getFilterTitle(filterName)),
                React.createElement("div", { className: 'm-filters__inner' }, filters),
                showMore));
        });
    };
    Filters.prototype.configureFilters = function (filters, filterName) {
        var _this = this;
        return filters.map(function (filter) {
            // tslint:disable-next-line
            var isSelected = filter.value === _this.props.filterStore.currentFilters[filterName] ? ' is-selected' : '';
            var onFilterClick = function () {
                _this.onFilterClick({ title: filterName, value: filter.value });
            };
            return (React.createElement("div", { className: "m-filters__filter" + isSelected, onClick: onFilterClick, key: filter.value },
                React.createElement("span", null, filter.title)));
        });
    };
    Filters.prototype.removeHash = function () {
        // tslint:disable-next-line
        this.props.globalStore.hashRouterService.removeHash();
    };
    Filters.prototype.render = function () {
        var filters = this.configureFilterBlocks();
        var mobileClassName = this.state.isOpened ? ' m-filters__is-opened' : '';
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'm-filters' },
                React.createElement("div", { className: 'm-filters__title m-filters__mobile-dropdown', onClick: this.toggleVisibility }, "Filters"),
                React.createElement("div", { className: "m-filters__content" + mobileClassName }, filters)),
            React.createElement("div", { className: 'm-filters__clear' },
                React.createElement(LeftRailButton_1.LeftRailButton, { title: 'Clear filter', onClick: this.resetFilters }))));
    };
    Filters = tslib_1.__decorate([
        mobx_react_1.inject('filterStore', 'timelineStore', 'globalStore'),
        mobx_react_1.observer
    ], Filters);
    return Filters;
}(React.Component));
exports.Filters = Filters;
